import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {LegalDocumentsApi} from 'Users/api';
import axiosInstance from 'Shared/utilities/axiosInstance';

const legalDocumentsApi = new LegalDocumentsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export const getLegalDocuments = () =>
  withCancellation(cancelToken => legalDocumentsApi.legalDocumentsGetAll('1', getAxiosConfig(cancelToken))).then(
    handleResponse
  );

export const getLegalDocumentText = (id: string) =>
  withCancellation(cancelToken => legalDocumentsApi.legalDocumentsGet(id, '1', getAxiosConfig(cancelToken))).then(
    handleResponse
  );
